import { render, staticRenderFns } from "./modelGuidance.vue?vue&type=template&id=66a5187c&scoped=true"
import script from "./modelGuidance.vue?vue&type=script&lang=js"
export * from "./modelGuidance.vue?vue&type=script&lang=js"
import style0 from "./modelGuidance.vue?vue&type=style&index=0&id=66a5187c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5187c",
  null
  
)

export default component.exports